export enum GenderKeyEnum {
  Male = 'M',
  Woman = 'K',
  Unknown = '*',
}
